<template>
  <li class="tree-item"
    :class="(!isTextNode && !isClearHighlight
      && currentIssue && currentIssue.id === nodeData.id) ? 'active-node' : ''">
    <span v-if="isTextNode">{{ nodeId }}</span>
    <div v-else :id="'code-id-' + nodeData.id">
      <div v-if="nodeData.docType">{{ nodeData.docType }}</div>
      <strong v-html="openTag"></strong><!--
      --><template v-if="nodeData.htmlId || nodeData.childIds.length"><!--
        --><template v-if="textOnlyContent && !nodeData.htmlId">{{ textOnlyContent }}</template><!--
        --><ul v-else class="tree-menu">
          <report-code-item v-if="nodeData.htmlId"
            :isClearHighlight="isClearHighlight"
            :nodeId="nodeData.htmlId"
            :nodeDataMap="nodeDataMap"
            :currentIssue="currentIssue" />
          <report-code-item v-else
            v-for="(childId, index) in nodeData.childIds" :key="index"
            :isClearHighlight="isClearHighlight"
            :nodeId="childId"
            :nodeDataMap="nodeDataMap"
            :currentIssue="currentIssue" />
        </ul>
      </template><!--
      --><strong v-if="!isSelfClosingTag">&lt;/{{ nodeData.tagName | lowercase }}&gt;</strong>
    </div>
  </li>
</template>

<script>
function escapeHtml (unsafe) {
  if (typeof unsafe !== 'string') {
    return ''
  }

  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

export default {
  name: 'ReportCodeItem',
  props: ['nodeDataMap', 'nodeId', 'currentIssue', 'isClearHighlight'],
  computed: {
    isTextNode () {
      return typeof this.nodeId === 'string'
    },
    nodeData () {
      return this.nodeDataMap[this.nodeId]
    },
    attrString () {
      const nodeData = this.nodeData
      return this.getAttrString(nodeData)
    },
    isSelfClosingTag () {
      switch (this.nodeData.tagName) {
        case 'BR':
        case 'IMG':
        case 'META':
        case 'LINK':
        case 'INPUT':
          return true
        default:
          return false
      }
    },
    openTag () {
      const tagName = this.nodeData.tagName.toLowerCase()
      const attr = this.attrString
      let html = `&lt;${tagName}<span>${attr}</span>`

      if (this.isSelfClosingTag) {
        html += ' /&gt;'
      } else {
        html += '&gt;'
      }
      return html
    },
    textOnlyContent () {
      const texts = []
      const childIds = this.nodeData.childIds

      for (let i = 0; i < childIds.length; i++) {
        const childId = childIds[i]

        if (typeof childId === 'string') {
          texts.push(childId)
        } else {
          const childNodeData = this.nodeDataMap[childId]

          if (childNodeData.tagName === 'BR') {
            const attr = this.getAttrString(childNodeData)
            texts.push(`<br${attr} />`)
          } else {
            return null
          }
        }
      }

      if (texts.length) {
        return texts.join(' ').trim()
      }
      return null
    }
  },
  watch: {
  },
  methods: {
    getAttrString (nodeData) {
      let attrValues = []

      if (nodeData.attrs) {
        for (let [key, value] of Object.entries(nodeData.attrs)) {
          key = escapeHtml(key)
          value = escapeHtml(value)
          attrValues.push(`${key}="${value}"`)
        }
      }

      if (attrValues.length) {
        return ' ' + attrValues.join(' ')
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/valid-member/report/ReportCodeItem.vue